import { captureReactException } from "@grafit/shared/observability/sentry-front";
import { createRootRoute } from "@tanstack/react-router";
import type { ErrorInfo } from "react";
import { NotFoundPage } from "../pages/not-found-page";
import { RootComponent } from "../scaffolding/root-component";
import { RootErrorFallbackWithAuth } from "../scaffolding/root-error-fallback";

export const Route = createRootRoute({
  component: RootComponent,
  // @ts-expect-error The onCatch api is not typed properly in the tanstack library -- errors thrown can have some info attached
  onCatch: (error: unknown, info: unknown): void => {
    captureReactException(error, info as ErrorInfo);
  },
  errorComponent: RootErrorFallbackWithAuth,
  notFoundComponent: () => <NotFoundPage />,
});
